import React from 'react'

import {
  AvailabilityIcon,
  FormIcon,
  ResultIcon,
  TestIcon,
  VideoIcon
} from '../assets/icons'

import ApplyNowButton from './ApplyNowButton'

const steps = [
  {
    icon: AvailabilityIcon,
    title: 'Register',
    description: [
      'Register at Devsnest School here',
      'Confirm your phone number and download the brochure'
    ]
  },
  {
    icon: FormIcon,
    title: 'Apply',
    description: [
      'Apply by submitting your name, school marks and other details'
    ]
  },
  {
    icon: TestIcon,
    title: 'Scholarship Test',
    description: [
      'Take the Online test, we will mail you everytime a slot opens up, it will also be shown on the website'
    ]
  },
  {
    icon: VideoIcon,
    title: 'Interview',
    description: [
      'After clearing the test, we will invite you for an interview'
    ]
  },
  {
    icon: ResultIcon,
    title: 'Result',
    description: ['Your candidature application results will be mailed to you']
  }
]

const AdmissionProcess = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 lg:max-w-screen-2xl lg:px-6 space-y-24 py-12 w-full">
      <div className="flex flex-col md:flex-row gap-4 md:items-center justify-between">
        <div>
          <h2 className="text-3xl font-medium">Admission Process</h2>
          <p className="mt-4 max-w-4xl text-base md:text-lg lg:text-xl text-zinc-700">
            Experience a Hassle-Free Admission with our easy 5 step process.
            Support is available at each step.
          </p>
        </div>

        <ApplyNowButton />
      </div>

      <ol className="mt-16 border-l border-gray-400 border-dashed md:flex md:justify-between md:gap-4 md:border-l-0 md:border-t">
        {steps.map((step, idx) => (
          <li key={idx} className="xl:min-w-[260px] min-w-none">
            <div className="-ml-[11px] mr-3 h-[22px] w-[22px] rounded-full border-2 bg-white border-orange-500 md:-mt-[11px] md:ml-0 md:mr-0" />
            <div className="ml-4 mt-2 md:ml-0 bg-white shadow-md rounded-lg p-4 flex flex-col gap-y-4 xl:min-h-[280px] min-h-none">
              <p className="text-sm font-medium text-gray-500">
                Step {idx + 1}
              </p>
              <step.icon />
              <h4 className="text-base md:text-lg lg:text-xl font-semibold">
                {step.title}
              </h4>
              {step.description.map((desc, idx) => (
                <p
                  className="text-gray-500 text-base md:text-lg break-words"
                  key={idx}>
                  {desc}
                </p>
              ))}
            </div>
          </li>
        ))}
      </ol>
    </div>
  )
}

export default AdmissionProcess
